import { motion } from "framer-motion";
import logo from "../../src/assets/images/logo.png";
// import bgImage from "../assets/images/bg-img.jpg";

const Loading = () => {
  return (
    <div
      className="fixed inset-0 bg-white bg-opacity-70  flex justify-center items-center z-50"
      // style={{
      //   backgroundImage: `url(${bgImage})`,
      //   backgroundRepeat: "no-repeat",
      //   backgroundSize: "cover",
      //   backgroundPosition: "center",
      // }}
    >
      <motion.div
        className="relative w-40 h-w-40 flex justify-center items-center rounded-full bg-blue-950 shadow-xl  border-2 border-white"
        animate={{
          scale: [1, 1.15, 1],
          opacity: [0.9, 1, 0.9],
          boxShadow: [
            "0px 0px 15px rgba(30, 58, 138, 0.4)",
            "0px 0px 25px rgba(30, 58, 138, 0.8)",
            "0px 0px 15px rgba(30, 58, 138, 0.4)",
          ],
        }}
        transition={{
          duration: 1.5,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      >
        <motion.img
          src={logo}
          alt="Loading Logo"
          className="w-40 h-40 object-contain rounded-full p-2"
          animate={{
            rotate: [0, 10, -10, 0],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
      </motion.div>
    </div>
  );
};

export default Loading;
